export function getChallengeGuestId() {
  const key = 'tl_v2_challenge_guest_id';
  try {
    let id = localStorage.getItem(key);
    if (!id) {
      const rand = Math.random().toString(36).slice(2, 10);
      id = `guest-${Date.now().toString(36)}-${rand}`;
      localStorage.setItem(key, id);
    }
    return id;
  } catch {
    return `guest-${Date.now().toString(36)}`;
  }
}

export function challengeStatLabel(value, fallback = '0') {
  const n = Number(value || 0);
  return Number.isFinite(n) ? n.toLocaleString('th-TH') : fallback;
}